import { tenderAIAPi } from './tender-ai-api';
import { convertModelToFormDataWithFileData } from './helpers';
const createCompany = (company) => {
    const formData = convertModelToFormDataWithFileData(company);
    var result = tenderAIAPi.postForm(`companies`, formData);
    return result;
};
const getCompanies = () => {
    return tenderAIAPi.get(`companies`);
};
const deleteCompany = (id) => {
    return tenderAIAPi.delete(`companies/${id}`);
};
const toggleCompanyActivation = (id) => {
    return tenderAIAPi.put(`companies/${id}/toggle-activation`);
};
const updateCompany = (company) => {
    const formData = convertModelToFormDataWithFileData(company);
    return tenderAIAPi.putForm(`companies/${company.id}`, formData);
};
const CompanyApi = {
    createCompany,
    getCompanies,
    deleteCompany,
    toggleCompanyActivation,
    updateCompany
};
export default CompanyApi;
